import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type {
	DeprecatedIntegrationsResponse,
	DiscontinuedIntegrationsResponse,
	IncomingCallResponse,
	IntegrationsCountsResponse,
	SyncedIntegrationsResponse,
} from '../../../../common/types';

const getIntegrationCounts = (cloudId: string) => {
	const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/count`;

	return performGetRequest<IntegrationsCountsResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getIntegrationCountsEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

const getSyncedIntegrations = (cloudId: string) => {
	const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/sync`;

	return performGetRequest<SyncedIntegrationsResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getSyncedIntegrationsEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

const getDiscontinuedIntegrations = (cloudId: string) => {
	const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/discontinued`;

	return performGetRequest<DiscontinuedIntegrationsResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getDiscontinuedIntegrationsEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

const getDeprecatedIntegrations = (cloudId: string) => {
	const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/deprecated`;

	return performGetRequest<DeprecatedIntegrationsResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getDeprecatedIntegrationsEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

const getIncomingCallIntegrations = (cloudId: string) => {
	const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/incoming-call`;

	return performGetRequest<IncomingCallResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getIncomingCallIntegrationsEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

export {
	getIntegrationCounts,
	getSyncedIntegrations,
	getDiscontinuedIntegrations,
	getDeprecatedIntegrations,
	getIncomingCallIntegrations,
};
